// Angular Imports
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
	selector: 'app-score-circle',
	standalone: true,
	imports: [],
	templateUrl: './score-circle.component.html',
	styleUrls: ['./score-circle.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScoreCircleComponent {
	value = input<number | null>(null)
	size = input<'sm' | 'md' | 'lg'>('md')
}
